<div class="phone-container">
	<img class="screen" [src]="screen()" [alt]="title()"/>
	<div class="placeholder">
		<img class="phone" src="img/skin/phone/smartphone-frame-overlay-exact.png" alt="app phone placeholder"/>
	</div>
</div>